var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    id: "support",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#343c4a",
    d: "M372.637 349.7H140.383V119.592A116.11 116.11 0 0 1 256.51 3.5a116.11 116.11 0 0 1 116.127 116.093Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7177db",
    d: "M440.622 511.999a10 10 0 0 0 10-10V401.036a70.02 70.02 0 0 0-41.665-64.017l-84.996-36.42a43.947 43.947 0 0 1-26.638-40.394v-7.697h-82.646v8.115a43.947 43.947 0 0 1-26.428 40.304l-84 36.511a70.02 70.02 0 0 0-42.871 64.538v100.023a10 10 0 0 0 10 10Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9beac",
    d: "M197.107 295.767a72.507 72.507 0 0 0 122.188 2.49 43.948 43.948 0 0 1-21.972-38.052v-7.697h-82.646v8.115a43.948 43.948 0 0 1-17.57 35.144zM383.88 511.999v-49.997h66.742v39.997a10 10 0 0 1-10 10zm-322.502-10v-39.997h66.742v49.997H71.378a10 10 0 0 1-10-10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbc5b",
    d: "M344.924 511.999V316.573a10.163 10.163 0 0 1 13.378-9.64l43.705 14.564a10.161 10.161 0 0 1 6.95 9.64v180.862Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 368.22,
    r: 7.623,
    fill: "#ffbc5b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 413.945,
    r: 7.623,
    fill: "#ffbc5b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbc5b",
    d: "M256 467.29a7.62 7.62 0 1 1 7.623-7.621 7.622 7.622 0 0 1-7.623 7.62"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#e58a7b",
    d: "M214.677 252.508v8.115a43.997 43.997 0 0 1-.301 5.127A82.298 82.298 0 0 0 270 287.29a82.329 82.329 0 0 0 32.412-6.609 43.84 43.84 0 0 1-5.09-20.476v-7.697Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9beac",
    d: "M256 266.29a82.602 82.602 0 0 1-82.602-82.602V82.86h165.204v100.827A82.602 82.602 0 0 1 256 266.29Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#596381",
    d: "M284 223.776c-1.876 0-3.555-.079-4.994-.192a3.5 3.5 0 1 1 .546-6.978 57.199 57.199 0 0 0 35.469-8.837c21.736-14.243 24.954-38.871 25.378-43.664a3.5 3.5 0 1 1 6.973.618c-.475 5.357-4.078 32.889-28.514 48.901A63.574 63.574 0 0 1 284 223.776Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#e58a7b",
    d: "M256.001 221.31a36.92 36.92 0 0 1-15.72-3.537 3.5 3.5 0 0 1 2.998-6.325 29.883 29.883 0 0 0 12.722 2.862h.09a29.898 29.898 0 0 0 12.63-2.862 3.5 3.5 0 0 1 2.998 6.325 36.937 36.937 0 0 1-15.608 3.537Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#343c4a",
    d: "M301.57 138.454a3.49 3.49 0 0 1-1.327-.263 27.72 27.72 0 0 0-21.087 0 3.5 3.5 0 0 1-2.658-6.476 34.634 34.634 0 0 1 12.32-2.596 35.181 35.181 0 0 1 14.08 2.596 3.5 3.5 0 0 1-1.329 6.74zm-11.871 17.992a3.5 3.5 0 0 1-3.5-3.5v-7.552a3.5 3.5 0 0 1 7 0v7.552a3.5 3.5 0 0 1-3.5 3.5zm-59.005-17.992a3.493 3.493 0 0 1-1.325-.262 27.72 27.72 0 0 0-21.088-.001 3.5 3.5 0 0 1-2.658-6.476 34.718 34.718 0 0 1 26.4 0 3.5 3.5 0 0 1-1.329 6.739zm-11.87 17.992a3.5 3.5 0 0 1-3.5-3.5v-7.552a3.5 3.5 0 0 1 7 0v7.552a3.5 3.5 0 0 1-3.5 3.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28.922,
    height: 17.996,
    x: 256.793,
    y: 211.438,
    fill: "#343c4a",
    rx: 8.998
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#f96263",
    d: "M338.602 121.113h20.673a13.363 13.363 0 0 1 13.362 13.363v33.73a13.363 13.363 0 0 1-13.363 13.363h-14.672a6 6 0 0 1-6-6v-54.456ZM167.397 181.569h-13.653a13.363 13.363 0 0 1-13.362-13.363v-33.73a13.363 13.363 0 0 1 13.362-13.363h19.653v54.456a6 6 0 0 1-6 6Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e58a7b",
    d: "M268.913 172.415v6.881A12.913 12.913 0 0 1 256 192.21h-.007a12.906 12.906 0 0 1-12.906-12.906v-6.888a3 3 0 0 1 3-3h19.826a3 3 0 0 1 3 3Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#343c4a",
    d: "M272.481 64.77c1.772-22.332 23.158-37.153 43.627-44.829a116.021 116.021 0 0 1 56.529 99.651v7.982a96.783 96.783 0 0 1-5.576 1.011 94.052 94.052 0 0 1-27.44 0c-42.274-5.63-69.279-36.842-67.14-63.815Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#343c4a",
    d: "M276.197 85.492a202.58 202.58 0 0 1-23.55 16.276 205.569 205.569 0 0 1-78.229 26.817h-34.035v-8.993A116.11 116.11 0 0 1 256.51 3.5a115.63 115.63 0 0 1 69.859 23.354"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3b4a9b",
    d: "M133.649 512a3.5 3.5 0 0 1-3.307-2.354 104.247 104.247 0 0 1-.704-65.813l2.27-7.03a56.84 56.84 0 0 0 2.75-17.454V401.2a3.5 3.5 0 0 1 7 0v18.15a63.835 63.835 0 0 1-3.088 19.604l-2.27 7.032a97.207 97.207 0 0 0 .656 61.367 3.503 3.503 0 0 1-3.307 4.648Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.de0b0e2b35884c458d0e6445db75c669.svg";
export { ForwardRef as ReactComponent };